<template>
    <router-link class='menu__button menu__button_list' v-bind:to='button.path' v-bind:class='{ menu__button_active : button.isActive }'>
        <font-awesome-icon  
            v-on:click='makeActive' 
            class='menu__icon' 
            icon="microphone"
            v-if='button.path == "\/"'
        ></font-awesome-icon>
        <font-awesome-icon  
            v-on:click='makeActive' 
            class='menu__icon' 
            icon="clipboard-list"
            v-if='button.path == "\/list"'
        ></font-awesome-icon>
        <font-awesome-icon  
            v-on:click='makeActive' 
            class='menu__icon' 
            icon="volume-down"
            v-if='button.path == "\/speaker"'
        ></font-awesome-icon>
    </router-link>
</template>

<script>
export default {
    name: 'MenuButton',
    props: ['button', 'index' ],
    data: function() {
        return {
            socket: ''
        }
    },
    methods: {
        makeActive: function(e) {
            this.$emit('switch', this.index );
        }
    },
    beforeMount: function() {
        // this.socket = Socket('https://voicy-speaker.herokuapp.com/');
    }
}
</script>

<style lang='less'>
.menu__button {
    width: 40px;
    height: 40px;
    background: #66DCAC;
    border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    transition: width 0.15s ease-in-out, height 0.15s ease-in-out;
 
    &_active {
        width: 50px;
        height: 50px;
        background-color: #41B883;

        svg {
            font-size: 28px;
        }
    }
}

.menu__icon {
    font-size: 21px;
    color: #E4FFF4;
    border-radius: 25px;
    transition: font-size 0.15s ease-in-out;
}
</style>